/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { ShareUrlResponseDto } from '../models';
import { VideoItemDto } from '../models';
import { VideosListResponseDto } from '../models';
/**
 * VideosApi - axios parameter creator
 * @export
 */
export const VideosApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Create a new predefined tag
     * @param {string} name
     * @param {string} description
     * @param {string} color
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerCreateTag: async (
      name: string,
      description: string,
      color: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      if (name === null || name === undefined) {
        throw new RequiredError(
          'name',
          'Required parameter name was null or undefined when calling videosControllerCreateTag.'
        );
      }
      // verify required parameter 'description' is not null or undefined
      if (description === null || description === undefined) {
        throw new RequiredError(
          'description',
          'Required parameter description was null or undefined when calling videosControllerCreateTag.'
        );
      }
      // verify required parameter 'color' is not null or undefined
      if (color === null || color === undefined) {
        throw new RequiredError(
          'color',
          'Required parameter color was null or undefined when calling videosControllerCreateTag.'
        );
      }
      const localVarPath = `/videos/admin/tags`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (description !== undefined) {
        localVarQueryParameter['description'] = description;
      }

      if (color !== undefined) {
        localVarQueryParameter['color'] = color;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a tag
     * @param {string} tag_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerDeleteTag: async (
      tag_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'tag_id' is not null or undefined
      if (tag_id === null || tag_id === undefined) {
        throw new RequiredError(
          'tag_id',
          'Required parameter tag_id was null or undefined when calling videosControllerDeleteTag.'
        );
      }
      const localVarPath = `/videos/admin/tags/{tagId}`.replace(
        `{${'tagId'}}`,
        encodeURIComponent(String(tag_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a video
     * @param {string} video_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerDeleteVideo: async (
      video_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'video_id' is not null or undefined
      if (video_id === null || video_id === undefined) {
        throw new RequiredError(
          'video_id',
          'Required parameter video_id was null or undefined when calling videosControllerDeleteVideo.'
        );
      }
      const localVarPath = `/videos/{videoId}`.replace(
        `{${'videoId'}}`,
        encodeURIComponent(String(video_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Download a video
     * @param {string} video_id
     * @param {string} range
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerDownloadVideo: async (
      video_id: string,
      range: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'video_id' is not null or undefined
      if (video_id === null || video_id === undefined) {
        throw new RequiredError(
          'video_id',
          'Required parameter video_id was null or undefined when calling videosControllerDownloadVideo.'
        );
      }
      // verify required parameter 'range' is not null or undefined
      if (range === null || range === undefined) {
        throw new RequiredError(
          'range',
          'Required parameter range was null or undefined when calling videosControllerDownloadVideo.'
        );
      }
      const localVarPath = `/videos/{videoId}`.replace(
        `{${'videoId'}}`,
        encodeURIComponent(String(video_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (range !== undefined && range !== null) {
        localVarHeaderParameter['range'] = String(range);
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Generate a shareable URL for a video
     * @param {string} video_id
     * @param {string} expiration_minutes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerGenerateShareUrl: async (
      video_id: string,
      expiration_minutes: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'video_id' is not null or undefined
      if (video_id === null || video_id === undefined) {
        throw new RequiredError(
          'video_id',
          'Required parameter video_id was null or undefined when calling videosControllerGenerateShareUrl.'
        );
      }
      // verify required parameter 'expiration_minutes' is not null or undefined
      if (expiration_minutes === null || expiration_minutes === undefined) {
        throw new RequiredError(
          'expiration_minutes',
          'Required parameter expiration_minutes was null or undefined when calling videosControllerGenerateShareUrl.'
        );
      }
      const localVarPath = `/videos/{videoId}/share`.replace(
        `{${'videoId'}}`,
        encodeURIComponent(String(video_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (expiration_minutes !== undefined) {
        localVarQueryParameter['expirationMinutes'] = expiration_minutes;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all predefined tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerGetAllTags: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/videos/admin/tags`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get tags subscribed by an organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerGetOrgSubscribedTags: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/videos/tags/org/{organizationId}`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get tags with statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerGetTagsWithStats: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/videos/admin/tags/stats`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List all videos with pagination
     * @param {string} limit
     * @param {string} offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerListVideos: async (
      limit: string,
      offset: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'limit' is not null or undefined
      if (limit === null || limit === undefined) {
        throw new RequiredError(
          'limit',
          'Required parameter limit was null or undefined when calling videosControllerListVideos.'
        );
      }
      // verify required parameter 'offset' is not null or undefined
      if (offset === null || offset === undefined) {
        throw new RequiredError(
          'offset',
          'Required parameter offset was null or undefined when calling videosControllerListVideos.'
        );
      }
      const localVarPath = `/videos`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Subscribe organizations to video tags
     * @param {string} organization_ids
     * @param {string} tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerSubscribeOrgsToTags: async (
      organization_ids: string,
      tags: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'organization_ids' is not null or undefined
      if (organization_ids === null || organization_ids === undefined) {
        throw new RequiredError(
          'organization_ids',
          'Required parameter organization_ids was null or undefined when calling videosControllerSubscribeOrgsToTags.'
        );
      }
      // verify required parameter 'tags' is not null or undefined
      if (tags === null || tags === undefined) {
        throw new RequiredError(
          'tags',
          'Required parameter tags was null or undefined when calling videosControllerSubscribeOrgsToTags.'
        );
      }
      const localVarPath = `/videos/tags/subscribe`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (organization_ids !== undefined) {
        localVarQueryParameter['organization_ids'] = organization_ids;
      }

      if (tags !== undefined) {
        localVarQueryParameter['tags'] = tags;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Unsubscribe organizations from video tags
     * @param {string} organization_ids
     * @param {string} tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerUnsubscribeOrgsFromTags: async (
      organization_ids: string,
      tags: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'organization_ids' is not null or undefined
      if (organization_ids === null || organization_ids === undefined) {
        throw new RequiredError(
          'organization_ids',
          'Required parameter organization_ids was null or undefined when calling videosControllerUnsubscribeOrgsFromTags.'
        );
      }
      // verify required parameter 'tags' is not null or undefined
      if (tags === null || tags === undefined) {
        throw new RequiredError(
          'tags',
          'Required parameter tags was null or undefined when calling videosControllerUnsubscribeOrgsFromTags.'
        );
      }
      const localVarPath = `/videos/tags/unsubscribe`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (organization_ids !== undefined) {
        localVarQueryParameter['organization_ids'] = organization_ids;
      }

      if (tags !== undefined) {
        localVarQueryParameter['tags'] = tags;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a tag
     * @param {string} tag_id
     * @param {string} name
     * @param {string} description
     * @param {string} color
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerUpdateTag: async (
      tag_id: string,
      name: string,
      description: string,
      color: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'tag_id' is not null or undefined
      if (tag_id === null || tag_id === undefined) {
        throw new RequiredError(
          'tag_id',
          'Required parameter tag_id was null or undefined when calling videosControllerUpdateTag.'
        );
      }
      // verify required parameter 'name' is not null or undefined
      if (name === null || name === undefined) {
        throw new RequiredError(
          'name',
          'Required parameter name was null or undefined when calling videosControllerUpdateTag.'
        );
      }
      // verify required parameter 'description' is not null or undefined
      if (description === null || description === undefined) {
        throw new RequiredError(
          'description',
          'Required parameter description was null or undefined when calling videosControllerUpdateTag.'
        );
      }
      // verify required parameter 'color' is not null or undefined
      if (color === null || color === undefined) {
        throw new RequiredError(
          'color',
          'Required parameter color was null or undefined when calling videosControllerUpdateTag.'
        );
      }
      const localVarPath = `/videos/admin/tags/{tagId}`.replace(
        `{${'tagId'}}`,
        encodeURIComponent(String(tag_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (description !== undefined) {
        localVarQueryParameter['description'] = description;
      }

      if (color !== undefined) {
        localVarQueryParameter['color'] = color;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update tags for a video
     * @param {string} video_id
     * @param {string} tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerUpdateVideoTags: async (
      video_id: string,
      tags: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'video_id' is not null or undefined
      if (video_id === null || video_id === undefined) {
        throw new RequiredError(
          'video_id',
          'Required parameter video_id was null or undefined when calling videosControllerUpdateVideoTags.'
        );
      }
      // verify required parameter 'tags' is not null or undefined
      if (tags === null || tags === undefined) {
        throw new RequiredError(
          'tags',
          'Required parameter tags was null or undefined when calling videosControllerUpdateVideoTags.'
        );
      }
      const localVarPath = `/videos/{videoId}/tags`.replace(
        `{${'videoId'}}`,
        encodeURIComponent(String(video_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (tags !== undefined) {
        localVarQueryParameter['tags'] = tags;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Upload a new video with optional thumbnail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    videosControllerUploadVideo: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/videos/upload`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * VideosApi - functional programming interface
 * @export
 */
export const VideosApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a new predefined tag
     * @param {string} name
     * @param {string} description
     * @param {string} color
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerCreateTag(
      name: string,
      description: string,
      color: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).videosControllerCreateTag(name, description, color, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Delete a tag
     * @param {string} tag_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerDeleteTag(
      tag_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).videosControllerDeleteTag(tag_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Delete a video
     * @param {string} video_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerDeleteVideo(
      video_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).videosControllerDeleteVideo(video_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Download a video
     * @param {string} video_id
     * @param {string} range
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerDownloadVideo(
      video_id: string,
      range: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).videosControllerDownloadVideo(video_id, range, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Generate a shareable URL for a video
     * @param {string} video_id
     * @param {string} expiration_minutes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerGenerateShareUrl(
      video_id: string,
      expiration_minutes: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<ShareUrlResponseDto>>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).videosControllerGenerateShareUrl(video_id, expiration_minutes, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get all predefined tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerGetAllTags(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs =
        await VideosApiAxiosParamCreator(
          configuration
        ).videosControllerGetAllTags(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get tags subscribed by an organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerGetOrgSubscribedTags(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<string>>>
    > {
      const localVarAxiosArgs =
        await VideosApiAxiosParamCreator(
          configuration
        ).videosControllerGetOrgSubscribedTags(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get tags with statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerGetTagsWithStats(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs =
        await VideosApiAxiosParamCreator(
          configuration
        ).videosControllerGetTagsWithStats(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary List all videos with pagination
     * @param {string} limit
     * @param {string} offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerListVideos(
      limit: string,
      offset: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<VideosListResponseDto>>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).videosControllerListVideos(limit, offset, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Subscribe organizations to video tags
     * @param {string} organization_ids
     * @param {string} tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerSubscribeOrgsToTags(
      organization_ids: string,
      tags: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).videosControllerSubscribeOrgsToTags(organization_ids, tags, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Unsubscribe organizations from video tags
     * @param {string} organization_ids
     * @param {string} tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerUnsubscribeOrgsFromTags(
      organization_ids: string,
      tags: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).videosControllerUnsubscribeOrgsFromTags(
        organization_ids,
        tags,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Update a tag
     * @param {string} tag_id
     * @param {string} name
     * @param {string} description
     * @param {string} color
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerUpdateTag(
      tag_id: string,
      name: string,
      description: string,
      color: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).videosControllerUpdateTag(tag_id, name, description, color, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Update tags for a video
     * @param {string} video_id
     * @param {string} tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerUpdateVideoTags(
      video_id: string,
      tags: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await VideosApiAxiosParamCreator(
        configuration
      ).videosControllerUpdateVideoTags(video_id, tags, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Upload a new video with optional thumbnail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerUploadVideo(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<VideoItemDto>>
    > {
      const localVarAxiosArgs =
        await VideosApiAxiosParamCreator(
          configuration
        ).videosControllerUploadVideo(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * VideosApi - factory interface
 * @export
 */
export const VideosApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Create a new predefined tag
     * @param {string} name
     * @param {string} description
     * @param {string} color
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerCreateTag(
      name: string,
      description: string,
      color: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return VideosApiFp(configuration)
        .videosControllerCreateTag(name, description, color, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a tag
     * @param {string} tag_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerDeleteTag(
      tag_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return VideosApiFp(configuration)
        .videosControllerDeleteTag(tag_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a video
     * @param {string} video_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerDeleteVideo(
      video_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return VideosApiFp(configuration)
        .videosControllerDeleteVideo(video_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Download a video
     * @param {string} video_id
     * @param {string} range
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerDownloadVideo(
      video_id: string,
      range: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return VideosApiFp(configuration)
        .videosControllerDownloadVideo(video_id, range, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Generate a shareable URL for a video
     * @param {string} video_id
     * @param {string} expiration_minutes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerGenerateShareUrl(
      video_id: string,
      expiration_minutes: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<ShareUrlResponseDto>> {
      return VideosApiFp(configuration)
        .videosControllerGenerateShareUrl(video_id, expiration_minutes, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all predefined tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerGetAllTags(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return VideosApiFp(configuration)
        .videosControllerGetAllTags(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get tags subscribed by an organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerGetOrgSubscribedTags(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<string>>> {
      return VideosApiFp(configuration)
        .videosControllerGetOrgSubscribedTags(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get tags with statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerGetTagsWithStats(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return VideosApiFp(configuration)
        .videosControllerGetTagsWithStats(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List all videos with pagination
     * @param {string} limit
     * @param {string} offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerListVideos(
      limit: string,
      offset: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<VideosListResponseDto>> {
      return VideosApiFp(configuration)
        .videosControllerListVideos(limit, offset, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Subscribe organizations to video tags
     * @param {string} organization_ids
     * @param {string} tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerSubscribeOrgsToTags(
      organization_ids: string,
      tags: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return VideosApiFp(configuration)
        .videosControllerSubscribeOrgsToTags(organization_ids, tags, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Unsubscribe organizations from video tags
     * @param {string} organization_ids
     * @param {string} tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerUnsubscribeOrgsFromTags(
      organization_ids: string,
      tags: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return VideosApiFp(configuration)
        .videosControllerUnsubscribeOrgsFromTags(
          organization_ids,
          tags,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a tag
     * @param {string} tag_id
     * @param {string} name
     * @param {string} description
     * @param {string} color
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerUpdateTag(
      tag_id: string,
      name: string,
      description: string,
      color: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return VideosApiFp(configuration)
        .videosControllerUpdateTag(tag_id, name, description, color, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update tags for a video
     * @param {string} video_id
     * @param {string} tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerUpdateVideoTags(
      video_id: string,
      tags: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return VideosApiFp(configuration)
        .videosControllerUpdateVideoTags(video_id, tags, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Upload a new video with optional thumbnail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async videosControllerUploadVideo(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<VideoItemDto>> {
      return VideosApiFp(configuration)
        .videosControllerUploadVideo(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * VideosApi - object-oriented interface
 * @export
 * @class VideosApi
 * @extends {BaseAPI}
 */
export class VideosApi extends BaseAPI {
  /**
   *
   * @summary Create a new predefined tag
   * @param {string} name
   * @param {string} description
   * @param {string} color
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public async videosControllerCreateTag(
    name: string,
    description: string,
    color: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return VideosApiFp(this.configuration)
      .videosControllerCreateTag(name, description, color, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Delete a tag
   * @param {string} tag_id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public async videosControllerDeleteTag(
    tag_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return VideosApiFp(this.configuration)
      .videosControllerDeleteTag(tag_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Delete a video
   * @param {string} video_id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public async videosControllerDeleteVideo(
    video_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return VideosApiFp(this.configuration)
      .videosControllerDeleteVideo(video_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Download a video
   * @param {string} video_id
   * @param {string} range
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public async videosControllerDownloadVideo(
    video_id: string,
    range: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return VideosApiFp(this.configuration)
      .videosControllerDownloadVideo(video_id, range, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Generate a shareable URL for a video
   * @param {string} video_id
   * @param {string} expiration_minutes
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public async videosControllerGenerateShareUrl(
    video_id: string,
    expiration_minutes: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<ShareUrlResponseDto>> {
    return VideosApiFp(this.configuration)
      .videosControllerGenerateShareUrl(video_id, expiration_minutes, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all predefined tags
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public async videosControllerGetAllTags(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return VideosApiFp(this.configuration)
      .videosControllerGetAllTags(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get tags subscribed by an organization
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public async videosControllerGetOrgSubscribedTags(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<string>>> {
    return VideosApiFp(this.configuration)
      .videosControllerGetOrgSubscribedTags(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get tags with statistics
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public async videosControllerGetTagsWithStats(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return VideosApiFp(this.configuration)
      .videosControllerGetTagsWithStats(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary List all videos with pagination
   * @param {string} limit
   * @param {string} offset
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public async videosControllerListVideos(
    limit: string,
    offset: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<VideosListResponseDto>> {
    return VideosApiFp(this.configuration)
      .videosControllerListVideos(limit, offset, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Subscribe organizations to video tags
   * @param {string} organization_ids
   * @param {string} tags
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public async videosControllerSubscribeOrgsToTags(
    organization_ids: string,
    tags: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return VideosApiFp(this.configuration)
      .videosControllerSubscribeOrgsToTags(organization_ids, tags, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Unsubscribe organizations from video tags
   * @param {string} organization_ids
   * @param {string} tags
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public async videosControllerUnsubscribeOrgsFromTags(
    organization_ids: string,
    tags: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return VideosApiFp(this.configuration)
      .videosControllerUnsubscribeOrgsFromTags(organization_ids, tags, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Update a tag
   * @param {string} tag_id
   * @param {string} name
   * @param {string} description
   * @param {string} color
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public async videosControllerUpdateTag(
    tag_id: string,
    name: string,
    description: string,
    color: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return VideosApiFp(this.configuration)
      .videosControllerUpdateTag(tag_id, name, description, color, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Update tags for a video
   * @param {string} video_id
   * @param {string} tags
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public async videosControllerUpdateVideoTags(
    video_id: string,
    tags: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return VideosApiFp(this.configuration)
      .videosControllerUpdateVideoTags(video_id, tags, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Upload a new video with optional thumbnail
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof VideosApi
   */
  public async videosControllerUploadVideo(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<VideoItemDto>> {
    return VideosApiFp(this.configuration)
      .videosControllerUploadVideo(options)
      .then((request) => request(this.axios, this.basePath));
  }
}
